export const httpStatusEnum = {
  SUCCESS: 200,
  UNDEFINED: 0,
  UNAUTHORIZED: 401,
  INTERNAL_SERVER_ERROR: 500,
  ANY_OTHER_EXCEPTION: 600,
  NOT_AUTHORIZED: 601,
  NOT_FOUND_DAO: 602,
  IMAGE_UPLOAD_EXCEPTION: 603,
  DOWNLOAD_EXCEPTION: 604,
  NOT_VALID_ACTION_EXCEPTION: 605,
  BAD_REQUEST: 606
};

export const AppStatusEnum = {
  ACTIVE: 'Active',
  INACTIVE: 'Inctive'
};

export const TE = {
  ID: `${process.env.REACT_APP_NAME}_`,
  DIV: '_div',
  LBL:'_label',
  BTN:'_button',
  CLNDR:'_calendar',
  TABLE:'_table',
  NOTIFIER:'_notifier',
  MSGCONTAINER:'_message_conainer',
  CLOSEBTN:'_close_button',
  CONFIRM:'_confirmation',
  CONFIRMBTN:'_confirmation_button',
  TITLE: '_title',
  IDPCONTENT: '_idp_content',
  TEXT: '_txt',
  SELECT: '_select',
  LINK: '_link',
  PROTCOL_INFO: 'protocol_information_'
};

export const armTextLength = 3;
export const armDescriptionLength = 250;
export const armReasonLength = 500;

export const cohortTextLength = 3;
export const cohortDescriptionLength = 250;
export const cohortReasonLength = 500;